import { Serializable } from "../utilities/Serializable";
import { AccountHolder } from "./AccountHolder";
import { CurrentAccountType } from "./CurrentAccountType";
import { Card } from "./Card";
import { Utils } from "../../providers/paytron-backend/utils";

export class CurrentAccount extends Serializable {
  uuid: string;
  checkIn: string;
  checkOut: string;
  balance: number;
  accountHolderType: AccountHolder;
  type: CurrentAccountType;
  accountHolderUuid: string;
  room: string;
  notes: string;
  cards: Card[];
  open: boolean;

  constructor() {
    super();
    this.checkIn = new Utils("en-US", null).toInputDateString(Date.now());
    this.accountHolderType = AccountHolder.Customer;
    this.type = CurrentAccountType.Flat;
    this.cards = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/CurrentAccount.ts